import { RendererLike } from "@connectv/html";


export function Hr(_: {}, renderer: RendererLike<unknown, unknown>) {
  return <hr/>
}
